export const getBookingErrorMessage = (errorBookingResponse: any, t: any): string => {
  if (Array.isArray(errorBookingResponse?.data?.fields) && errorBookingResponse?.data?.fields.length > 0) {
    return errorBookingResponse?.data?.fields.map((f: any) => `• ${f?.errorMessage}`).join("\n");
  } else {
    return t("bookingForm.error.message");
  }
};
